import mitt, { Emitter } from 'mitt';

let _workbenchInfoEmitter:
  | Emitter<{
      'get-team-config': boolean | undefined; // 获取工作区信息
      'toggle-work-user-dialog-modal': boolean;
    }>
  | undefined;

/** 工作区 事件总池 */
export const getWorkbenchEmitter = () => {
  return _workbenchInfoEmitter || (_workbenchInfoEmitter = mitt());
};
